import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductConfig } from '../@types/context/product-config.types';
import type { ProductCreditCardConfig } from '../@types/context/product-credit-card-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactAxoFiConfig } from './presets/contact-axo-fi.config';
import { creditCardFiConfig } from './presets/credit-card-fi.config';
import { insuranceMypageFi } from './presets/insurance-mypage.config';
import { globalFi } from './presets/global-fi.config';
import { myPageCcd2FiOptions } from './presets/mypage-ccd2-fi.config';
import { myPageOffersFiConfig } from './presets/mypage-offers-fi.config';
import { productConfigFi } from './presets/product-config.preset';
import { organisationAxoFiConfig } from './presets/organisation-axo-fi.config';
import { serviceTrustpilotAxoFiConfig } from './presets/service-trustpilot-axo-fi.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansFiConfig } from './presets/unsecured-loans-fi.config';

export const global: GlobalConfig = {
  brand: 'axolaina.fi',
  ...globalFi,
};

export const site: SiteConfig = {
  domain: 'axolaina.fi',
  name: 'Axolaina',
  theme: {
    name: 'axo-finans',
    brand: 'axo-laina',
  },
  path: {
    loansApply: '/hae/kulutusluotto',
    loansPreForm: '/laina',
    mypage: 'https://omatsivut.axolaina.fi',
    insurance: '/hae/matsurvaraus',
    // site-one mypage paths (path-based, not subdomain)
    mypageOverview: '/omat-sivut',
    mypageLoans: '/omat-sivut/lainat',
    mypageCreditCards: '/omat-sivut/luottokortit',
    creditCard: '/hae/luottokortti',
    oneFormPreflight: '/hae/tunnistautuminen',
    oneFormApply: '/hae/laina',
    oneFormRecommendations: '/hae/kulutusluotto/lisatuotteet',
    ...insuranceMypageFi,
  },
  ...organisationAxoFiConfig,
  ...contactAxoFiConfig,
  services: {
    cms: {
      provider: 'prepr',
    },
    cookieConsentManager: {
      provider: 'cookieyes',
      cookieyes: {
        siteId: {
          production: 'fba195dd3224d8a539d14e1c1369839c',
          staging: '16868e3c66c4ae44b118a469e1621174',
        },
        scriptStrategy: 'lazyOnload',
      },
    },
    // Live TrustScore as review-snippet stars in the page JSON-LD (MVF-132).
    trustpilot: {
      ...serviceTrustpilotAxoFiConfig,
      reviewSnippet: true,
      showInForms: true,
    },
    gtm: 'GTM-KJPKCM9',
    ga: 'G-XNWPL5CZQM',
    // SPIKE: defer GTM off the critical path so third-party tags injected via
    // the container (CAPI, pixels, etc.) don't block first paint / TBT. Measure
    // PageSpeed delta before deciding to keep. Trade-off: GA + tags fire later.
    gtmScriptStrategy: 'lazyOnload',
    launchDarkly: {
      enabled: true,
      anonymousExperimentsEnabled: false,
    },
    statsig: {
      enabled: true,
      autoCapture: false,
      sessionReplay: false,
      proxyEnabled: true,
    },
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansFiConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const productCreditCard: ProductCreditCardConfig = {
  ...creditCardFiConfig,
};

export const myPage: MyPageConfig = {
  options: {
    hasHighCostWarning: false,
    isCreditCardRecommendedVisible: false,
    creditCard: { hasApplyForm: false },
    ...myPageOffersFiConfig,
    ...myPageCcd2FiOptions,
  },
};

export const product: ProductConfig = productConfigFi;
